import Step3 from '@/Classes/FollowUp/FollowUpPatint';
import Vue from 'vue';
export default {
  data() {
    return {
      isDriveTroma: false,
      isNotDrivingTroma: false,
      isBrain: false,
      isHeart: false,
      isParturition: false,
      isIllness: false,
      release: '',
      otherDiagnosisDetail: '',
      scoreApgar1: null,
      scoreApgar2: null,
      scoreApgar3: null,
      tempParturitionDate: '',
      tempParturitionDateApgar1: '',
      tempParturitionDateApgar2: '',
      tempParturitionDateApgar3: '',
      showParturitionDate: false,
      showParturitionDateApgar1: false,
      showParturitionDateApgar2: false,
      showParturitionDateApgar3: false,
      //truma options
      transitTypeList: [
        { title: 'زمینی-جاده ای', id: 1 },
        { title: 'زمینی-ریلی', id: 2 },
        { title: 'هوایی', id: 3 },
        { title: 'دریایی', id: 4 },
      ],
      vehicleTypeList: [
        { title: 'موتور سیکلت', id: 1 },
        { title: 'سبک', id: 2 },
        { title: 'سنگین', id: 3 },
        { title: 'دوچرخه', id: 4 },
        { title: 'سایر', id: 5 },
      ],
      vehicleTypeOther: '',
      patientStateList: [
        { title: 'عابر', id: 1 },
        { title: 'سرنشین', id: 2 },
        { title: 'راننده', id: 3 },
        { title: 'راکب موتور یا دوچرخه', id: 4 },
        { title: 'سایر', id: 5 },
      ],
      patientStateOther: '',

      //********************************************************************************** */
      brainDiagnosisTypeList: [
        { title: 'CVA', id: 1 },
        { title: 'TIA', id: 2 },
        { title: 'CVA(FAST+) کد سما', id: 3 },
        { title: 'CVA(FAST-)', id: 4 },
        { title: 'مننگو آتسفالیت', id: 5 },
        { title: 'سایر', id: 6 },
      ],
      heartDiagnosisTypeList: [
        { title: 'دیس ریتمی', id: 1 },
        { title: 'STEMI(247)', id: 2 },
        { title: 'ACS (سندرم حاد کرونر)', id: 3 },
        { title: 'ادم حاد ریه / CHF', id: 4 },
        { title: 'فشارخون بالا', id: 5 },
        { title: 'کاهش فشار خون', id: 6 },
        { title: 'ایست قلبی تنفسی', id: 7 },
        { title: 'سایر', id: 8 },
      ],
      illnessDiagnosisTypeList: [
        { title: 'اورژانس های تنفسی', id: 2 },
        { title: 'اورژانس های دیابت', id: 3 },
        { title: 'اورژانس های رفتاری', id: 4 },
        { title: 'اختلالات نورولوژیک به غیر از CVA', id: 5 },
        { title: 'بیماری های عفونی', id: 6 },
        { title: 'اورژانس های جراحی', id: 7 },
        { title: 'اورژانس های زنان', id: 8 },
        { title: 'ضعف و بیحالی با احتمال اختلالات الکترولیتی', id: 9 },
        { title: 'شوک با علت نامشخص', id: 10 },
        // { title: 'سایر', id: 11 },
      ],
      parturitionDiagnosisTypeList: [
        { title: 'اکلامپسی', id: 1 },
        { title: 'پره اکلامپسی', id: 2 },
        { title: 'زایمان', id: 3 },
        { title: 'سقط', id: 4 },
        { title: 'سایر', id: 5 },
      ],
      parturitionFetalPositionTypeList: [
        { title: 'سفالیک', id: 1 },
        { title: 'بریج', id: 2 },
        { title: 'سایر', id: 3 },
      ],
      parturitionFetalPositionTypeObj: {
        'سفالیک': 1,
        'بریج': 2,
        'سایر': 3,
        1: 'سفالیک',
        2: 'بریج',
        3: 'سایر',
      },
      childTypeList: [
        { title: 'دختر', id: 1 },
        { title: 'پسر', id: 2 },
        { title: 'نامشخص', id: 3 },
      ],
      childTypeObj: {
        'دختر': 1,
        'پسر': 2,
        'نامشخص': 3,
        1: 'دختر',
        2: 'پسر',
        3: 'نامشخص',
      },
      ///
      heartRateTypeList: [
        { title: 'ندارد', id: 1, score: 0 },
        { title: 'کمتر از 100 بار در دقیقه', id: 2, score: 1 },
        { title: 'بیشتر از 100 بار در دقیقه', id: 3, score: 2 },
      ],
      tonicityTypeList: [
        { title: 'ندارد', id: 1, score: 0 },
        { title: 'فلکسیون مختصر اندام', id: 2, score: 1 },
        { title: 'دست و پا به خوبی خم می شود', id: 3, score: 2 },
      ],
      breathingTypeList: [
        { title: 'ندارد', id: 1, score: 0 },
        { title: 'گریه ضعیف', id: 2, score: 1 },
        { title: 'گریه شدید', id: 3, score: 2 },
      ],
      reactionTypeList: [
        { title: 'ندارد', id: 1, score: 0 },
        { title: 'کمی حرکت می کند', id: 2, score: 1 },
        { title: 'خود را عقب می کشد', id: 3, score: 2 },
      ],
      colorBodyTypeList: [
        { title: 'آبی', id: 1, score: 0 },
        { title: 'بدن صورتی - اندام آبی', id: 2, score: 1 },
        { title: 'بدن و اندام صورتی', id: 3, score: 2 },
      ],

      accidentTypeList: [
        { title: 'سقوط', id: 1 },
        { title: 'گاز گزفتگی', id: 2 },
        { title: 'غرق شدگی در آب', id: 3 },
        { title: 'انسداد راه هوایی', id: 4 },
        { title: 'برق گرفتگی', id: 5 },
        { title: 'سرمازدگی', id: 6 },
        { title: 'گرمازدگی', id: 7 },
        { title: 'حیوان گزیدگی', id: 8 },
        { title: 'ارتفاع زدگی', id: 19 },
        { title: 'گزش حشرات و خزندگان و گیاهان سمی', id: 9 },
        { title: 'سوختگی', id: 10 },
        { title: 'مسمومیت', id: 11 },
        { title: 'برخورد با نیروهای بی جان', id: 12 },
        { title: 'حوادث عمدی', id: 13 },
        { title: 'مسمومیت گوارشی', id: 14 },
        { title: 'آلرژی', id: 15 },
        { title: 'آسیب با جسم برنده', id: 16 },
        { title: 'تیرخوردگی', id: 17 },
        { title: 'انفجار', id: 18 },


      ],
      fallTypeList: [
        { title: 'سقوط همتراز', id: 1 },
        { title: 'سقوط غیر همتراز', id: 2 },
      ],
      burnTypeList: [
        { title: 'جسم داغ', id: 1 },
        { title: 'شیمیایی', id: 2 },
        { title: 'مایع داغ', id: 3 },
        { title: 'حریق', id: 4 },
        { title: 'سایر', id: 5 },
      ],
      allergyList: [
        { title: 'آلرژی', id: 1 },
        { title: 'آنافیلاکسی', id: 2 },
      ],
      biteTypeList: [
        { title: 'زنبور', id: 1 },
        { title: 'مار', id: 2 },
        { title: 'عقرب', id: 3 },
        { title: 'عنکبوت', id: 4 },
        { title: 'رتیل', id: 5 },
        { title: 'سفره ماهی', id: 6 },
        { title: 'توتیا(ستاره دریایی)', id: 7 },
        { title: 'سایر', id: 8 },
      ],
      poisoningTypeList: [
        { title: 'مسمومیت - co', id: 1 },
        { title: 'مسمومیت - کلر', id: 2 },
        { title: 'مسمومیت - دارو', id: 3 },
        { title: 'مسمومیت - مواد مخدر', id: 4 },
        { title: 'مسمومیت - مواد محرک', id: 5 },
        { title: 'مسمومیت - سموم', id: 6 },
        { title: 'مسمومیت - الکل', id: 7 },
        { title: 'مسمومیت - گاز گرفتگی', id: 8 },
        { title: 'سایر', id: 9 },
      ],
      deliberateAccidentTypeList: [
        { title: 'خشونت علیه خود(خودکشی)', id: 1 },
        { title: 'خشونت بین افراد', id: 2 },
        { title: 'خشونت های اجتماعی', id: 3 },
        { title: 'سایر', id: 4 },
      ],
      //موارد مربووط به بیماری ها
      respiratoryEmergencyTypeList: [
        { title: 'آمبولی ریه', id: 1 },
        { title: 'پنوموتوراکس', id: 2 },
        { title: 'آسم COPD', id: 3 },
        { title: 'پنومونی', id: 4 },
        { title: 'اپیگلوتیت-کروپ-سرماخوردگی', id: 5 },
        { title: 'مشکلات تنفسی', id: 6 },
      ],
      diabetesEmergencyTypeList: [
        { title: 'هیپرگلیسمی', id: 1 },
        { title: 'هیپوگلیسمی', id: 2 },
        { title: 'DKA', id: 3 },
        { title: 'هایپراسمولار', id: 4 },
      ],
      behavioralEmergencyTypeList: [
        { title: 'سایکوتیک', id: 1 },
        { title: 'غیر سایکوتیک', id: 2 },
        { title: 'اختلالات اضطرابی با احتمال بیماری جسمی', id: 3 },
      ],
      neurologicalEmergencyTypeList: [
        { title: 'تشنج', id: 1 },
        { title: 'مننگو آنسفالیت', id: 2 },
        { title: 'فلج بل', id: 3 },
        { title: 'فلج بالارونده', id: 4 },
        { title: 'فلج پایین رونده', id: 5 },
        { title: 'سردرد', id: 6 },
        { title: 'سرگیجه', id: 7 },
        { title: 'کمر درد', id: 8 },

      ],
      infectiousDiseasesTypeList: [
        { title: 'HIV', id: 1 },
        { title: 'هپاتیتB', id: 2 },
        { title: 'هپاتیتC', id: 3 },
        { title: 'TB', id: 4 },
      ],
      surgicalEmergencyTypeList: [
        // { title: 'آپاندیسیت', id: 1 },
        { title: 'شکم حاد', id: 2 },
        // { title: 'پانکراتیت', id: 3 },
        { title: 'ایسکمی اندام ها', id: 4 },
        // { title: 'آنوریسم آئورت', id: 5 },
      ],
      WomenEmergencTypeList: [
        { title: 'شک به حاملگی نابجا', id: 1 },
        { title: 'سقط', id: 2 },
        { title: 'اکلامپسی', id: 3 },
        { title: 'پره اکلامپسی', id: 4 },
        { title: 'خونریزی واژینال', id: 5 },
      ],
      patientDetail: new Step3.Step3(
        null,
        '',
        '',
        null,
        null,
        new Step3.PatientMovementAbility(true, true, true, true),
        new Step3.PatientTraumaDetail('', '', '', null, null, null, null),
        new Step3.PatientParturitionDetail(null, null, null, null, null, null, null),
        []
        // [new Step3.PatientParturitionBabies(null, null, null, null, null, [new Step3.PatientApgarDetails(null, null, null, null, null, null, null)])]
      ),
      missionType: null,
    };
  },
  methods: {
    resetPatientDetail() {
      this.isDriveTroma = false;
      this.isNotDrivingTroma = false;
      this.isBrain = false;
      this.isHeart = false;
      this.isIllness = false;
      this.isParturition = false;
      this.missionType = null;
      this.otherDiagnosisDetail = '';
      this.vehicleTypeOther = '';
      this.patientStateOther = '';
      this.tempParturitionDate = '';
      this.tempParturitionDateApgar1 = '';
      this.tempParturitionDateApgar2 = '';
      this.tempParturitionDateApgar3 = '';
      this.scoreApgar1 = null;
      this.scoreApgar2 == null;
      this.scoreApgar3 = null;

      this.patientDetail = new Step3.Step3(
        null,
        '',
        '',
        null,
        null,
        new Step3.PatientMovementAbility(true, true, true, true),
        new Step3.PatientTraumaDetail('', '', '', null, null, null, null),
        new Step3.PatientParturitionDetail(null, null, null, null, null, null, null),
        // []
        [new Step3.PatientParturitionBabies(null, null, null, null, null, [
          new Step3.PatientApgarDetails(null, 1, null, null, null, null, null),
          new Step3.PatientApgarDetails(null, 2, null, null, null, null, null),
          new Step3.PatientApgarDetails(null, 3, null, null, null, null, null),
        ], null)]
      );
    },
    missionTypeChange(type) {
      const configs = {
        1: { typeOfEmergencyId: 1, missionType: 1, missionMainType: 'truma', diagnosis: 'تصادفات', isDriveTroma: true },
        2: { typeOfEmergencyId: 2, missionType: 2, missionMainType: 'illness', diagnosis: '', isNotDrivingTroma: true },
        3: { typeOfEmergencyId: 3, missionType: 3, missionMainType: 'illness', diagnosis: 'سکته مغزی', isBrain: true },
        4: { typeOfEmergencyId: 3, missionType: 4, missionMainType: 'illness', diagnosis: 'مشکلات قلبی', isHeart: true },
        5: { typeOfEmergencyId: 3, missionType: 5, missionMainType: 'illness', diagnosis: '', isIllness: true },
        6: { typeOfEmergencyId: 3, missionType: 6, missionMainType: 'parturition', diagnosis: 'زایمان', isParturition: true },
      };

      const config = configs[type];
      if (!config) {
        // console.log('نوع ماموریت نامعتبر:', type);
        return;
      }

      this.resetPatientDetail();

      Object.assign(this, {
        isDriveTroma: config.isDriveTroma || false,
        isNotDrivingTroma: config.isNotDrivingTroma || false,
        isBrain: config.isBrain || false,
        isHeart: config.isHeart || false,
        isIllness: config.isIllness || false,
        isParturition: config.isParturition || false,
      });

      this.patientDetail.typeOfEmergencyId = config.typeOfEmergencyId;
      this.missionType = config.missionType;
      this.patientDetail.diagnosis = config.diagnosis;

      if (type !== 6) {
        this.patientDetail.patientParturitionBabies = []
      }

      if (type !== 1) {
        this.patientDetail.patientMovementAbility.leftHand = null;
        this.patientDetail.patientMovementAbility.leftLeg = null;
        this.patientDetail.patientMovementAbility.rightHand = null;
        this.patientDetail.patientMovementAbility.rightLeg = null;
      }

      this.$root.$refs.FollowUpPatient.typeOfEmergencyId = config.typeOfEmergencyId;
      this.$root.$refs.FollowUpPatient.missionType = config.missionType;
      this.$root.$refs.FollowUpPatient.missionMainType = config.missionMainType;
    },
    accidentTypeChange: function () {
      //نوع حادثه تغییر کند
      this.patientDetail.diagnosisDetail = '';
      this.otherDiagnosisDetail = '';
      this.patientDetail.fallHeight = null;
    },
    diagnosisChange: function () {
      this.patientDetail.diagnosisDetail = '';
      this.otherDiagnosisDetail = '';
      this.patientDetail.patientParturitionDetail.beforeCodeArrival = null;
      this.patientDetail.patientParturitionDetail.isMultiple = null;
      this.patientDetail.patientParturitionDetail.pregnancyAge = null;
      this.patientDetail.patientParturitionDetail.numberOfParturition = null;
      this.patientDetail.patientParturitionDetail.numberOfMiscarriage = null;
      this.patientDetail.patientParturitionDetail.numberOfSuccessfulParturition = null;
      this.patientDetail.patientParturitionDetail.hasParturitionDone = null;
      this.tempParturitionDate = '';
      this.tempParturitionDateApgar1 = '';
      this.tempParturitionDateApgar2 = '';
      this.tempParturitionDateApgar3 = '';
      this.scoreApgar1 = null;
      this.scoreApgar2 == null;
      this.scoreApgar3 = null;
      this.patientDetail.fallHeight = null;
    },
    diagnosisDetailChange: function () {
      this.otherDiagnosisDetail = '';
    },
    timeToSeconds: function (time) {
      const parts = time.split(':');
      const hours = parseInt(parts[0]);
      const minutes = parseInt(parts[1]);
      // const seconds = parseInt(parts[2]);
      const seconds = 0;

      return hours * 3600 + minutes * 60 + seconds;
    },
    clearDateTime: function (type) {
      if (type == 'parturitionDate') {
        this.showParturitionDate = false;
        this.parturitionDateBabies = '';
        this.tempParturitionDate = '';
      }
      if (type == 'parturitionDateApgar1') {
        this.showParturitionDateApgar1 = false;
        this.parturitionDateBabiesApgar1 = '';
        this.tempParturitionDateApgar1 = '';
      }
      if (type == 'parturitionDateApgar2') {
        this.showParturitionDateApgar2 = false;
        this.parturitionDateBabiesApgar2 = '';
        this.tempParturitionDateApgar2 = '';
      }
      if (type == 'parturitionDateApgar3') {
        this.showParturitionDateApgar3 = false;
        this.parturitionDateBabiesApgar3 = '';
        this.tempParturitionDateApgar3 = '';
      }
    },
    dateTimeChange: function (type) {
      if (type === 'parturitionDate') {
        if (this.parturitionDateBabies) {
          this.tempParturitionDate = this.parturitionDateBabies;
        } else {
          this.tempParturitionDate = '';
        }
      }
      if (type === 'parturitionDateApgar1') {
        if (this.parturitionDateBabiesApgar1) {
          this.tempParturitionDateApgar1 = this.parturitionDateBabiesApgar1;
        } else {
          this.tempParturitionDateApgar1 = '';
        }
      }
      if (type === 'parturitionDateApgar2') {
        if (this.parturitionDateBabiesApgar2) {
          this.tempParturitionDateApgar2 = this.parturitionDateBabiesApgar2;
        } else {
          this.tempParturitionDateApgar2 = '';
        }
      }
      if (type === 'parturitionDateApgar3') {
        if (this.parturitionDateBabiesApgar3) {
          this.tempParturitionDateApgar3 = this.parturitionDateBabiesApgar3;
        } else {
          this.tempParturitionDateApgar3 = '';
        }
      }
    },
    vehicleTypeChange: function () {
      this.vehicleTypeOther = '';
    },
    patientStateChange: function () {
      this.patientStateOther = '';
    },
    goToStep4: function () {
      if (!this.missionType) {
        this.showErrorAlert('نوع ماموریت را وارد نمایید');
        return;
      }
      if (this.missionType == 1) {
        this.patientDetail.diagnosisDetail = '';
        //ترومایی مرتبظ با حمل و نقل
        if (!this.patientDetail.patientTraumaDetail.transitType) {
          this.showErrorAlert('نوع تردد را وارد نمایید');
          return;
        }
        if (!this.patientDetail.patientTraumaDetail.vehicleType) {
          this.showErrorAlert('نوع وسیله نقلیه را وارد نمایید');
          return;
        }
        if (this.patientDetail.patientTraumaDetail.vehicleType == 'سایر') {
          if (!this.vehicleTypeOther) {
            this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
            return;
          }
        }
        if (!this.patientDetail.patientTraumaDetail.patientState) {
          this.showErrorAlert('وضعیت مصدوم را وارد نمایید');
          return;
        }
        if (this.patientDetail.patientTraumaDetail.patientState == 'سایر') {
          if (!this.patientStateOther) {
            this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
            return;
          }
        }
        if (!this.release) {
          this.showErrorAlert('رهاسازی بیمار را وارد نمایید');
          return;
        }
      } else if (this.missionType == 2) {
        //تروما / حادثه غیر مرتبط با حمل نقل
        if (!this.patientDetail.diagnosis) {
          this.showErrorAlert('نوع حادثه را وارد نمایید');
          return;
        }
        if (this.patientDetail.diagnosis == 'سقوط') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع سقوط را وارد نمایید');
            return;
          }

          if (!this.patientDetail.fallHeight && this.patientDetail.diagnosisDetail == "سقوط غیر همتراز") {
            this.showErrorAlert('ارتفاع سقوط را وارد نمایید');
            return;
          }
        } else if (this.patientDetail.diagnosis == 'سوختگی') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع سوختگی را وارد نمایید');
            return;
          }
          if (this.patientDetail.diagnosisDetail == 'سایر') {
            if (!this.otherDiagnosisDetail) {
              this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
              return;
            }
          }
        } else if (this.patientDetail.diagnosis == 'گزش حشرات و خزندگان و گیاهان سمی') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع گزش را وارد نمایید');
            return;
          }
          if (this.patientDetail.diagnosisDetail == 'سایر') {
            if (!this.otherDiagnosisDetail) {
              this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
              return;
            }
          }
        } else if (this.patientDetail.diagnosis == 'آلرژی') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع آلرژی را وارد نمایید');
            return;
          }
        } else if (this.patientDetail.diagnosis == 'مسمومیت') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع مسمومیت را وارد نمایید');
            return;
          }
          if (this.patientDetail.diagnosisDetail == 'سایر') {
            if (!this.otherDiagnosisDetail) {
              this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
              return;
            }
          }
        } else if (this.patientDetail.diagnosis == 'حوادث عمدی') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع حادثه عمدی را وارد نمایید');
            return;
          }
          if (this.patientDetail.diagnosisDetail == 'سایر') {
            if (!this.otherDiagnosisDetail) {
              this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
              return;
            }
          }
        }
      } else if (this.missionType == 3) {
        //سکته مغزی
        if (!this.patientDetail.diagnosisDetail) {
          this.showErrorAlert('تشخیص را وارد نمایید');
          return;
        }
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          if (!this.otherDiagnosisDetail) {
            this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
            return;
          }
        }
      } else if (this.missionType == 4) {
        //مشکلات قلبی
        if (!this.patientDetail.diagnosisDetail) {
          this.showErrorAlert('تشخیص را وارد نمایید');
          return;
        }
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          if (!this.otherDiagnosisDetail) {
            this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
            return;
          }
        }
      } else if (this.missionType == 5) {
        //سایر بیماری ها
        if (!this.patientDetail.diagnosis) {
          this.showErrorAlert('تشخیص را وارد نمایید');
          return;
        }
        if (this.patientDetail.diagnosis == 'اورژانس های تنفسی') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع اورژانس تنفسی را وارد نمایید');
            return;
          }
        } else if (this.patientDetail.diagnosis == 'اورژانس های دیابت') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع اورژانس دیابت را وارد نمایید');
            return;
          }
        } else if (this.patientDetail.diagnosis == 'اورژانس های رفتاری') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع اورژانس رفتاری را وارد نمایید');
            return;
          }
        } else if (this.patientDetail.diagnosis == 'اختلالات نورولوژیک به غیر از CVA') {
          if (!this.patientDetail.diagnosisDetail) {
            this.showErrorAlert('نوع اختلالات نورولوژیک را وارد نمایید');
            return;
          }
        } else
          //   if (this.patientDetail.diagnosis == 'بیماری های عفونی') {
          //   if (!this.patientDetail.diagnosisDetail) {
          //     this.showErrorAlert('نوع بیماری عفونی را وارد نمایید');
          //     return;
          //   }
          // } else
          if (this.patientDetail.diagnosis == 'اورژانس های جراحی') {
            if (!this.patientDetail.diagnosisDetail) {
              this.showErrorAlert('نوع اورژاانس جراحی را وارد نمایید');
              return;
            }
          } else if (this.patientDetail.diagnosis == 'اورژانس های زنان') {
            if (!this.patientDetail.diagnosisDetail) {
              this.showErrorAlert('نوع اورژانس زنان را وارد نمایید');
              return;
            }
          } else if (this.patientDetail.diagnosis == 'سایر') {
            if (!this.otherDiagnosisDetail) {
              this.showErrorAlert('سایر با ذکر نام را وارد نمایید');
              return;
            }
          }
      } else if (this.missionType == 6) {

        if (!this.patientDetail.diagnosisDetail) {
          this.showErrorAlert('تشخیص را وارد نمایید');
          return;
        }
        if (this.patientDetail.patientParturitionDetail.hasParturitionDone == null) {
          this.showErrorAlert('آیا زایمان انجام شده است ؟');
          return;
        }

        if (this.patientDetail.patientParturitionDetail.hasParturitionDone) {
          if (this.patientDetail.patientParturitionDetail.beforeCodeArrival == null) {
            this.showErrorAlert('زمان زایمان  قبل/بعد از رسیدن کد را وارد نمایید');
            return;
          }

          if (this.patientDetail.patientParturitionBabies[0]?.isFetalPlacentaOut == null) {
            this.showErrorAlert('خروج جفت را وارد نمایید');
            return;
          }
          if (!this.patientDetail.patientParturitionBabies[0]?.parturitionDate) {

            this.showErrorAlert('ساعت زایمان را وارد نمایید');
            return;
          }
          if (this.patientDetail.patientParturitionBabies[0]?.gender == null) {
            this.showErrorAlert('جنسیت را وارد نمایید');
            return;
          }
          if (this.patientDetail.patientParturitionBabies[0]?.fetalPositionId == null) {
            this.showErrorAlert('نمای زایمان را وارد نمایید');
            return;
          }
          if (!this.patientDetail.patientParturitionBabies[0]?.patientApgarDetails[0]?.timeInSeconds ||
            this.patientDetail.patientParturitionBabies[0]?.patientApgarDetails[0]?.heartBeatId == null
          ) {
            this.showErrorAlert('آپگار هنگام تولد را وارد نمایید');
            return;
          }
          if (!this.patientDetail.patientParturitionBabies[0]?.patientApgarDetails[1]?.timeInSeconds ||
            !this.patientDetail.patientParturitionBabies[0]?.patientApgarDetails[1]?.heartBeatId == null
          ) {
            this.showErrorAlert('آپگار ده دقیقه بعد از تولد را وارد نمایید');
            return;
          }
          if (!this.patientDetail.patientParturitionBabies[0]?.patientApgarDetails[2]?.timeInSeconds ||
            !this.patientDetail.patientParturitionBabies[0]?.patientApgarDetails[2]?.heartBeatId == null
          ) {
            this.showErrorAlert('آپگار هنگام تحویل را وارد نمایید');
            return;
          }

          this.patientDetail.patientParturitionBabies[0].patientId = this.patientId;
          //جمع آپگار
          this.patientDetail.patientParturitionBabies[0].totalScore = Number(this.scoreApgar1) + Number(this.scoreApgar2) + Number(this.scoreApgar3);
        } else {
          this.patientDetail.patientParturitionBabies = []
        }

      }
      if (this.patientDetail.patientTraumaDetail) {
        if (this.patientDetail.patientTraumaDetail.vehicleType == 'سایر') {
          this.patientDetail.patientTraumaDetail.vehicleType = this.vehicleTypeOther;
        }
        if (this.patientDetail.patientTraumaDetail.patientState == 'سایر') {
          this.patientDetail.patientTraumaDetail.patientState = this.patientStateOther;
        }
      }
      if (this.patientDetail.diagnosis == 'سوختگی') {
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          this.patientDetail.diagnosisDetail = this.otherDiagnosisDetail;
        }
      }
      if (this.patientDetail.diagnosis == 'گزش حشرات و خزندگان و گیاهان سمی') {
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          this.patientDetail.diagnosisDetail = this.otherDiagnosisDetail;
        }
      }
      if (this.patientDetail.diagnosis == 'مسمومیت') {
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          this.patientDetail.diagnosisDetail = this.otherDiagnosisDetail;
        }
      }
      if (this.patientDetail.diagnosis == 'حوادث عمدی') {
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          this.patientDetail.diagnosisDetail = this.otherDiagnosisDetail;
        }
      }
      if (this.patientDetail.diagnosis == 'سکته مغزی') {
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          this.patientDetail.diagnosisDetail = this.otherDiagnosisDetail;
        }
      }
      if (this.patientDetail.diagnosis == 'مشکلات قلبی') {
        if (this.patientDetail.diagnosisDetail == 'سایر') {
          this.patientDetail.diagnosisDetail = this.otherDiagnosisDetail;
        }
      }
      if (this.missionType == 1) {
        if (this.release == 'before') {
          this.patientDetail.patientTraumaDetail.releaseBefore = true;
          this.patientDetail.patientTraumaDetail.releaseAfter = false;
        } else if (this.release == 'after') {
          this.patientDetail.patientTraumaDetail.releaseBefore = false;
          this.patientDetail.patientTraumaDetail.releaseAfter = true;
        }
      } else {
        this.patientDetail.patientTraumaDetail = null;
        this.patientDetail.patientMovementAbility = null;
      }

      if (this.missionType == 5 || this.missionType == 6) {
        if (this.patientDetail.diagnosis == 'سایر') {
          this.patientDetail.diagnosis = this.otherDiagnosisDetail;
        }
      }

      if (this.missionType != 6) {
        this.patientDetail.patientParturitionDetail = null;
      }

      if (this.patientDetail.patientParturitionDetail) {
        this.patientDetail.patientParturitionDetail.numberOfParturition = Number(this.patientDetail.patientParturitionDetail.numberOfParturition);
        this.patientDetail.patientParturitionDetail.numberOfSuccessfulParturition = Number(this.patientDetail.patientParturitionDetail.numberOfSuccessfulParturition);
        this.patientDetail.patientParturitionDetail.numberOfMiscarriage = Number(this.patientDetail.patientParturitionDetail.numberOfMiscarriage);
        this.patientDetail.patientParturitionDetail.pregnancyAge = Number(this.patientDetail.patientParturitionDetail.pregnancyAge);
      }

      this.patientDetail.patientId = this.patientId;

      if (this.missionType == 6) {
        const myData = JSON.parse(JSON.stringify(this.patientDetail));
        if (myData.diagnosisDetail == 'سایر') {
          myData.diagnosisDetail = this.otherDiagnosisDetail;
        }
        if (myData.patientParturitionDetail.hasParturitionDone) {
          myData.patientParturitionBabies[0].fetalPositionId = this.parturitionFetalPositionTypeObj[myData.patientParturitionBabies[0]?.fetalPositionId]
          myData.patientParturitionBabies[0].gender = this.childTypeObj[myData.patientParturitionBabies[0]?.gender]

          myData.patientParturitionBabies[0].parturitionDate = myData.patientParturitionBabies[0].parturitionDate + ':00'

          if (myData.patientParturitionBabies?.[0]?.patientApgarDetails) {
            myData.patientParturitionBabies[0].patientApgarDetails =
              myData.patientParturitionBabies[0].patientApgarDetails.map(item => ({
                ...item,
                timeInSeconds: this.timeToSeconds(item.timeInSeconds)
              }));
          }
        }

        this.addPatientDetailFunction(myData);
      } else {
        this.patientDetail.patientParturitionBabies = null
        this.addPatientDetailFunction(this.patientDetail);
      }

    },
    patientDetailAdded: function () {
      this.$root.$refs.FollowUpPatient.hasMisssionType = true;
      this.$root.$refs.FollowUpPatient.changeTab1Step(4, true);
    },
    setData: function (data) {
      this.patientDetail.diagnosisDetail = '';
      this.otherDiagnosisDetail = '';
      this.$root.$refs.FollowUpPatient.hasMisssionType = true;
      this.patientDetail.patientId = data.id;
      if (data.typeOfEmergency.title == 'ترومایی مرتبط با حمل و نقل') {
        this.isDriveTroma = true;
        this.isNotDrivingTroma = false;
        this.isBrain = false;
        this.isHeart = false;
        this.isIllness = false;
        this.isParturition = false;
        this.patientDetail.typeOfEmergencyId = 1;
        this.missionType = 1;
        this.$root.$refs.FollowUpPatient.typeOfEmergencyId = 1;
        this.$root.$refs.FollowUpPatient.missionType = 1;
        this.$root.$refs.FollowUpPatient.missionMainType = 'truma';
        this.patientDetail.diagnosis = 'تصادفات';
        this.patientDetail.diagnosisDetail = data.diagnosisDetail;
      } else if (data.typeOfEmergency.title == "ترومایی غیرمرتبط با حمل و نقل") {
        this.isDriveTroma = false;
        this.isNotDrivingTroma = true;
        this.isBrain = false;
        this.isHeart = false;
        this.isIllness = false;
        this.isParturition = false;
        this.patientDetail.typeOfEmergencyId = 2;
        this.missionType = 2;
        this.$root.$refs.FollowUpPatient.typeOfEmergencyId = 2;
        this.$root.$refs.FollowUpPatient.missionType = 2;
        this.$root.$refs.FollowUpPatient.missionMainType = 'illness';
        this.patientDetail.diagnosis = data.diagnosis;
        if (data.diagnosis == 'سوختگی') {
          let flag = false;
          for (let i = 0; i < this.burnTypeList.length; i++) {
            if (data.diagnosisDetail == this.burnTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
        }
        if (data.diagnosis == 'گزش حشرات و خزندگان و گیاهان سمی') {
          let flag = false;
          for (let i = 0; i < this.biteTypeList.length; i++) {
            if (data.diagnosisDetail == this.biteTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
        }
        if (data.diagnosis == 'آلرژی') {
          let flag = false;
          for (let i = 0; i < this.allergyList.length; i++) {
            if (data.diagnosisDetail == this.allergyList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
        }
        if (data.diagnosis == 'مسمومیت') {
          let flag = false;
          for (let i = 0; i < this.poisoningTypeList.length; i++) {
            if (data.diagnosisDetail == this.poisoningTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
        }
        if (data.diagnosis == 'حوادث عمدی') {
          let flag = false;
          for (let i = 0; i < this.deliberateAccidentTypeList.length; i++) {
            if (data.diagnosisDetail == this.deliberateAccidentTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
        }
        if (data.diagnosis == 'سقوط') {
          this.patientDetail.diagnosisDetail = data.diagnosisDetail;
        }
      } else if (data.typeOfEmergency.title == 'بیماری') {
        if (data.diagnosis == 'سکته مغزی') {
          let flag = false;
          for (let i = 0; i < this.brainDiagnosisTypeList.length; i++) {
            if (data.diagnosisDetail == this.brainDiagnosisTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
          this.isDriveTroma = false;
          this.isNotDrivingTroma = false;
          this.isBrain = true;
          this.isHeart = false;
          this.isIllness = false;
          this.isParturition = false;
          this.patientDetail.typeOfEmergencyId = 3;
          this.missionType = 3;
          this.$root.$refs.FollowUpPatient.typeOfEmergencyId = 3;
          this.$root.$refs.FollowUpPatient.missionType = 3;
          this.$root.$refs.FollowUpPatient.missionMainType = 'illness';
          this.patientDetail.diagnosis = data.diagnosis;
          this.vehicleTypeOther = '';
          this.patientStateOther = '';
        } else if (data.diagnosis == 'مشکلات قلبی') {
          let flag = false;
          for (let i = 0; i < this.heartDiagnosisTypeList.length; i++) {
            if (data.diagnosisDetail == this.heartDiagnosisTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
          this.isDriveTroma = false;
          this.isNotDrivingTroma = false;
          this.isBrain = false;
          this.isHeart = true;
          this.isIllness = false;
          this.isParturition = false;
          this.patientDetail.typeOfEmergencyId = 3;
          this.missionType = 4;
          this.$root.$refs.FollowUpPatient.typeOfEmergencyId = 3;
          this.$root.$refs.FollowUpPatient.missionType = 4;
          this.$root.$refs.FollowUpPatient.missionMainType = 'illness';
          this.patientDetail.diagnosis = data.diagnosis;
          this.vehicleTypeOther = '';
          this.patientStateOther = '';
        } else if (data.diagnosis == 'زایمان') {
          let flag = false;
          for (let i = 0; i < this.parturitionDiagnosisTypeList.length; i++) {
            if (data.diagnosisDetail == this.parturitionDiagnosisTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosisDetail = 'سایر';
            this.otherDiagnosisDetail = data.diagnosisDetail;
          } else {
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
          this.isDriveTroma = false;
          this.isNotDrivingTroma = false;
          this.isBrain = false;
          this.isHeart = false;
          this.isIllness = false;
          this.isParturition = true;
          this.patientDetail.typeOfEmergencyId = 3;
          this.missionType = 6;
          this.$root.$refs.FollowUpPatient.typeOfEmergencyId = 3;
          this.$root.$refs.FollowUpPatient.missionType = 6;
          this.$root.$refs.FollowUpPatient.missionMainType = 'parturition';
          this.patientDetail.diagnosis = data.diagnosis;
          this.vehicleTypeOther = '';
          this.patientStateOther = '';
        } else {
          let flag = false;
          for (let i = 0; i < this.illnessDiagnosisTypeList.length; i++) {
            if (data.diagnosis == this.illnessDiagnosisTypeList[i].title) {
              flag = true;
            }
          }
          if (flag == false) {
            this.patientDetail.diagnosis = 'سایر';
            this.otherDiagnosisDetail = data.diagnosis;
          } else {
            this.patientDetail.diagnosis = data.diagnosis;
            this.patientDetail.diagnosisDetail = data.diagnosisDetail;
          }
          this.isDriveTroma = false;
          this.isNotDrivingTroma = false;
          this.isBrain = false;
          this.isHeart = false;
          this.isIllness = true;
          this.patientDetail.typeOfEmergencyId = 3;
          this.missionType = 5;
          this.$root.$refs.FollowUpPatient.typeOfEmergencyId = 3;
          this.$root.$refs.FollowUpPatient.missionType = 5;
          this.$root.$refs.FollowUpPatient.missionMainType = 'illness';
          this.vehicleTypeOther = '';
          this.patientStateOther = '';
          this.patientDetail.patientMovementAbility.leftHand = null;
          this.patientDetail.patientMovementAbility.leftLeg = null;
          this.patientDetail.patientMovementAbility.rightHand = null;
          this.patientDetail.patientMovementAbility.rightLeg = null;
        }
      }
      this.patientDetail.fallHeight = data.height;
      if (data.patientMovementAbility) {
        this.patientDetail.patientMovementAbility.leftHand = data.patientMovementAbility.leftHand;
        this.patientDetail.patientMovementAbility.leftLeg = data.patientMovementAbility.leftLeg;
        this.patientDetail.patientMovementAbility.rightHand = data.patientMovementAbility.rightHand;
        this.patientDetail.patientMovementAbility.rightLeg = data.patientMovementAbility.rightLeg;
      } else {
        this.patientDetail.patientMovementAbility.leftHand = null;
        this.patientDetail.patientMovementAbility.leftLeg = null;
        this.patientDetail.patientMovementAbility.rightHand = null;
        this.patientDetail.patientMovementAbility.rightLeg = null;
      }
      if (data.patientParturitionDetail) {
        this.patientDetail.patientParturitionDetail.beforeCodeArrival = data.patientParturitionDetail.beforeCodeArrival;
        this.patientDetail.patientParturitionDetail.isMultiple = data.patientParturitionDetail.isMultiple;
        this.patientDetail.patientParturitionDetail.pregnancyAge = data.patientParturitionDetail.pregnancyAge;
        this.patientDetail.patientParturitionDetail.numberOfParturition = data.patientParturitionDetail.numberOfParturition;
        this.patientDetail.patientParturitionDetail.numberOfMiscarriage = data.patientParturitionDetail.numberOfMiscarriage;
        this.patientDetail.patientParturitionDetail.numberOfSuccessfulParturition = data.patientParturitionDetail.numberOfSuccessfulParturition;
        this.patientDetail.patientParturitionDetail.hasParturitionDone = data.patientParturitionDetail?.hasParturitionDone;

        this.tempParturitionDate = Vue.moment(data.patientParturitionDetail.parturitionDate).format('HH:mm:ss jYYYY-jMM-jDD',);
      } else {
        this.patientDetail.patientParturitionDetail.beforeCodeArrival = null;
        this.patientDetail.patientParturitionDetail.isMultiple = null;
        this.patientDetail.patientParturitionDetail.pregnancyAge = null;
        this.patientDetail.patientParturitionDetail.numberOfParturition = null;
        this.patientDetail.patientParturitionDetail.numberOfMiscarriage = null;
        this.patientDetail.patientParturitionDetail.numberOfSuccessfulParturition = null;
        this.patientDetail.patientParturitionDetail.hasParturitionDone = null;

        this.tempParturitionDate = '';
        this.tempParturitionDateApgar1 = '';
        this.tempParturitionDateApgar2 = '';
        this.tempParturitionDateApgar3 = '';
        this.scoreApgar1 = null;
        this.scoreApgar2 == null;
        this.scoreApgar3 = null;
      }
      if (data.patientTraumaDetail) {
        this.patientDetail.patientTraumaDetail.transitType = data.patientTraumaDetail.transitType;
        let vhicleTypeFlag = false;
        let patientStateFlag = false;
        this.patientDetail.patientTraumaDetail.policeCode = data.patientTraumaDetail.policeCode;
        this.patientDetail.patientTraumaDetail.vehiclePlateNumber =
          data.patientTraumaDetail.vehiclePlateNumber;
        for (let i = 0; i < this.vehicleTypeList.length; i++) {
          if (data.patientTraumaDetail.vehicleType == this.vehicleTypeList[i].title) {
            vhicleTypeFlag = true;
          }
        }
        for (let i = 0; i < this.patientStateList.length; i++) {
          if (data.patientTraumaDetail.patientState == this.patientStateList[i].title) {
            patientStateFlag = true;
          }
        }
        if (vhicleTypeFlag == true) {
          this.patientDetail.patientTraumaDetail.vehicleType = data.patientTraumaDetail.vehicleType;
        } else {
          this.patientDetail.patientTraumaDetail.vehicleType = 'سایر';
          this.vehicleTypeOther = data.patientTraumaDetail.vehicleType;
        }
        if (patientStateFlag == true) {
          this.patientDetail.patientTraumaDetail.patientState =
            data.patientTraumaDetail.patientState;
        } else {
          this.patientDetail.patientTraumaDetail.patientState = 'سایر';
          this.patientStateOther = data.patientTraumaDetail.patientState;
        }
        if (data.patientTraumaDetail.releaseAfter == true) {
          this.release = 'after';
          this.patientDetail.patientTraumaDetail.releaseAfter = true;
          this.patientDetail.patientTraumaDetail.releaseBefore = false;
        }
        if (data.patientTraumaDetail.releaseBefore == true) {
          this.release = 'before';
          this.patientDetail.patientTraumaDetail.releaseAfter = false;
          this.patientDetail.patientTraumaDetail.releaseBefore = true;
        }
      } else {
        this.patientDetail.patientTraumaDetail.transitType = '';
        this.patientDetail.patientTraumaDetail.patientState = '';
        this.patientDetail.patientTraumaDetail.vehicleType = '';
        this.patientDetail.patientTraumaDetail.releaseAfter = null;
        this.patientDetail.patientTraumaDetail.releaseBefore = null;
      }
      if (data.patientParturitionBabies?.length > 0) {
        const myBabiesApi = data.patientParturitionBabies[0]
        let arrApgar = [
          new Step3.PatientApgarDetails(null, 1, null, null, null, null, null),
          new Step3.PatientApgarDetails(null, 2, null, null, null, null, null),
          new Step3.PatientApgarDetails(null, 3, null, null, null, null, null),
        ]

        if (myBabiesApi.patientApgarDetails?.length > 0) {
          arrApgar = myBabiesApi.patientApgarDetails.map((item, index) => {
            let sumNum = 0
            sumNum += (item.heartBeat?.id || 0) - 1;
            sumNum += (item.muscleTone?.id || 0) - 1;
            sumNum += (item.babyRespiration?.id || 0) - 1;
            sumNum += (item.babyReactionToStimulation?.id || 0) - 1;
            sumNum += (item.babyBodyColor?.id || 0) - 1; // ✅ اصلاح شد

            if (index == 0) {
              this.scoreApgar1 = sumNum
              this.tempParturitionDateApgar1 = item.time?.replace(/:00$/, '')
            }
            if (index == 1) {
              this.scoreApgar2 = sumNum
              this.tempParturitionDateApgar2 = item.time?.replace(/:00$/, '')
            }
            if (index == 2) {
              this.scoreApgar3 = sumNum
              this.tempParturitionDateApgar3 = item.time?.replace(/:00$/, '')
            }


            return {
              timeInSeconds: item.time?.replace(/:00$/, ''),
              patientApgarType: item.patientApgarType,
              heartBeatId: item.heartBeat?.id ?? null,
              muscleToneId: item.muscleTone?.id ?? null,
              babyRespirationId: item.babyRespiration?.id ?? null,
              babyReactionToStimulationId: item.babyReactionToStimulation?.id ?? null,
              babyBodyColorId: item.babyBodyColor?.id ?? null,
            }
          });
        }

        this.patientDetail.patientParturitionBabies = [new Step3.PatientParturitionBabies(
          this.childTypeObj[myBabiesApi.gender],
          myBabiesApi.isFetalPlacentaOut,
          myBabiesApi.totalScore,
          data.id,
          this.parturitionFetalPositionTypeObj[myBabiesApi?.fetalPosition?.id],
          arrApgar,
          myBabiesApi.parturitionDate?.replace(/:00$/, ''))]
        this.tempParturitionDate = myBabiesApi.parturitionDate?.replace(/:00$/, '')

      } else {
        this.patientDetail.patientParturitionBabies = null
      }
    },
    backToStep2: function () {
      this.$root.$refs.FollowUpPatient.changeTab1Step(2, true);
    },
  },
};
